import React, { useState, useEffect } from 'react';
import { Box, Button, Grid, Card, CardContent, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Alert, CircularProgress } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import ModuleHub from '../components/ModuleHub';
import { getCashFlowSummary } from '../../../services/api';

const CashFlowPage = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => { loadData(); }, []);
  const loadData = async () => {
    try { setLoading(true); const r = await getCashFlowSummary(); setData(r.data); }
    catch (err) { setError(err.message); } finally { setLoading(false); }
  };

  const fmt = (v) => parseFloat(v || 0).toLocaleString('en-LK', { style: 'currency', currency: 'LKR' });

  return (
    <ModuleHub moduleId="bank-cash" showFeatures={false}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Button startIcon={<RefreshIcon />} onClick={loadData}>Refresh</Button>
      </Box>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {loading ? <CircularProgress /> : data && (
        <>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            {[
              { label: 'Total Cash Position', value: data.totalBalance, color: '#7c3aed' },
              { label: 'Recent Inflow', value: data.inflow, color: '#16a34a' },
              { label: 'Recent Outflow', value: data.outflow, color: '#dc2626' }
            ].map(c => (
              <Grid item xs={12} md={4} key={c.label}>
                <Card sx={{ borderLeft: `4px solid ${c.color}` }}><CardContent>
                  <Typography color="text.secondary">{c.label}</Typography>
                  <Typography variant="h5" fontWeight={700}>{fmt(c.value)}</Typography>
                </CardContent></Card>
              </Grid>
            ))}
          </Grid>
          <Typography variant="h6" gutterBottom>Recent Transactions</Typography>
          <TableContainer component={Paper}><Table size="small">
            <TableHead><TableRow><TableCell>Date</TableCell><TableCell>Account</TableCell><TableCell>Type</TableCell><TableCell align="right">Amount</TableCell></TableRow></TableHead>
            <TableBody>{(data.recentTransactions || []).map(t => (
              <TableRow key={t.id}>
                <TableCell>{t.transaction_date}</TableCell>
                <TableCell>{t.bankAccount?.account_name}</TableCell>
                <TableCell>{t.transaction_type}</TableCell>
                <TableCell align="right">{fmt(t.amount)}</TableCell>
              </TableRow>
            ))}</TableBody>
          </Table></TableContainer>
        </>
      )}
    </ModuleHub>
  );
};

export default CashFlowPage;
